import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabsinicio',
  templateUrl: './tabsinicio.component.html',
  styleUrls: ['./tabsinicio.component.css']
})
export class TabsinicioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
